module.exports = __webpack_public_path__ + "7cf04b73e8fff039985e2a82252612ff.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-94@2x.png
// module id = 546
// module chunks = 0